import {Injectable} from "@angular/core";
import {CacheService} from "../../../../packages/ahoracrypto-client-common/src/app/common/cache/cache.service";
import {ContentControllerService} from "../../../../packages/ahoracrypto-api-sdk/sdk";
import {I18nServices} from "../../../../packages/ahoracrypto-client-common/src/app/common/i18n/i18n.service";

@Injectable({
  providedIn: 'root'
})
export class ContentService {

  protected fixedContents = [
    'como-comprar-bitcoin-aprende-a-usar-ahoracrypto-para-comprar-btc',
    'la-adopcion-de-bitcoin-en-el-salvador-segun-nayib-bukele',
    'la-vision-radical-de-vitalik-buterin-para-la-pseudo-descentralizacion-de-ciudades-enteras'
    ];

  public constructor(protected cacheService: CacheService,
                     protected contentControllerService: ContentControllerService,
                     protected i18nServices: I18nServices) {
  }

  public loadLatest3Article(): Promise<any> {
    return new Promise((resolve, reject) => {
      if(this.cacheService.hasLatest3Articles()) {
        resolve(this.cacheService.getLatest3Articles());
      }
      else {
        this.contentControllerService.contentControllerFindAll(1, 3).subscribe((contents) => {
          //add all articles to cache
          contents.pop(); //always remove last one!
          this.cacheService.setLatest3Articles(contents);
          resolve(contents);
        });
      }
    });
  }

  public loadFixedContent(): Promise<any> {
      return Promise.all(this.fixedContents.map(code => this.loadContentByCode(code)));
  }

  public loadContentByCode(code: string): Promise<any> {
    return new Promise((resolve, reject) => {
      if(this.cacheService.hasContent(code)) {
        resolve(this.cacheService.getContent(code));
      } else {
        this.contentControllerService.contentControllerFindByCodeAndLanguageIsoCode(code, this.i18nServices.getLanguageIsoCode()).subscribe(content => {
          if(content != null) {
            this.cacheService.setContent(code, content);
            resolve(content);
          }
          else {
            reject();
          }
        });
      }
    });
  }

}
